module.exports = __webpack_public_path__ + "static/img/QRcode.ebc0587.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/QRcode.png
// module id = v6vf
// module chunks = 1